export default "__VITE_ASSET__3aecd47b__"